import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import './i18n'
import './index.css'
import { initTheme } from './lib/theme'
import { App } from './App'

initTheme()

registerSW({ immediate: true })

// Prevent pinch-zoom gestures and multi-touch zoom on mobile/PWA
if (typeof window !== 'undefined') {
  document.addEventListener('gesturestart', ((e: Event) => e.preventDefault()) as EventListener)
  document.addEventListener('gesturechange', ((e: Event) => e.preventDefault()) as EventListener)
  document.addEventListener('gestureend', ((e: Event) => e.preventDefault()) as EventListener)

  document.addEventListener(
    'touchstart',
    (e: TouchEvent) => {
      if (e.touches.length > 1) {
        e.preventDefault()
      }
    },
    { passive: false }
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
